import dayjs from "dayjs";

// Normalize month names for parsing
const normalizeMonth = (text: string) =>
  text.replace(
    /\b(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)\b/gi,
    (m) => m.charAt(0).toUpperCase() + m.slice(1)
  );

export const parseDate = (value: string) => {
  const normalized = normalizeMonth(value);
  const formats = ["D MMM", "DD MMM", "D MMMM", "DD MMMM", "YYYY-MM-DD"];
  const d = dayjs(normalized, formats, true);
  return d.isValid() ? d : null;
};

// Detect type automatically
export const detectLeaveType = (q: string) => {
  if (q.includes("sick")) return "Sick Leave";
  if (q.includes("casual")) return "Casual Leave";
  if (q.includes("annual")) return "Annual Leave";
  return null;
};

// Extract date phrases
export const detectDates = (q: string) => {
  const dateMatches = q.match(/\b\d{1,2} ?(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)\b/gi);

  if (!dateMatches) return null;

  if (dateMatches.length === 1) {
    const d = parseDate(dateMatches[0]);
    if (!d) return null;
    return { from: d.format("YYYY-MM-DD"), to: d.format("YYYY-MM-DD") };
  }

  if (dateMatches.length >= 2) {
    const d1 = parseDate(dateMatches[0]);
    const d2 = parseDate(dateMatches[1]);
    if (d1 && d2) {
      return {
        from: d1.format("YYYY-MM-DD"),
        to: d2.format("YYYY-MM-DD"),
      };
    }
  }

  return null;
};

// Detect 3 days, 2 days etc
export const detectDayCount = (q: string) => {
  const m = q.match(/(\d+)\s*(day|days)/);
  return m ? parseInt(m[1]) : null;
};
